import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SideNavButtonModel } from './side-nav.model';


@Component({
  moduleId: module.id,
  selector: 'status-sidenav',
  templateUrl: 'status-sidenav.component.html',
  styleUrls: ['status-sidenav.component.scss'],
})
export class StatusSideNavComponent {

  @Input() status: string;

  @Input() topButton: SideNavButtonModel;
  @Output() topButtonClicked  = new EventEmitter();

  @Input() bottomButton: SideNavButtonModel;
  @Output() bottomButtonClicked  = new EventEmitter();

  @Input() lastPublishedDate: string;

  @Input() blured: boolean = false;

  @Output() closeClicked = new EventEmitter();

  get displayStatus(): string {
    if (!this.status) { return ''; }
    return this.status;
  }

  get displayLastPublishedDate(): string {
    if (!this.lastPublishedDate) { return ''; }
    return 'Last Published Date ' + this.lastPublishedDate;
  }

  onCloseClick() {
    this.closeClicked.emit();
  }

  onTopButtonClick() {
    this.topButtonClicked.emit(this.topButton.value);
  }

  onBottomButtonClick() {
    this.bottomButtonClicked.emit(this.bottomButton.value);
  }
}
